<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :exportDataOptions="exportDataOptions" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getNameFilter, getDescriptionFilter } from '@/utils/common/tableFilter'
import expectStatus from '@/constants/expectStatus'
import SingleActionsMixin from '../mixins/singleActions'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'McpList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: Object,
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'mcp_agents',
        getParams: this.getParam,
        filterOptions: {
          name: getNameFilter(),
          description: getDescriptionFilter(),
          llm_driver: {
            label: this.$t('ai.mcp.llm_driver'),
            dropdown: true,
            items: [
              { label: this.$t('ai.mcp.ollama'), key: 'ollama' },
              { label: this.$t('ai.mcp.openai'), key: 'openai' },
            ],
          },
          model: {
            label: this.$t('ai.mcp.model'),
            filter: true,
            formatter: val => {
              return `model.contains("${val}")`
            },
          },
          llm_url: {
            label: this.$t('ai.mcp.llm_url'),
            filter: true,
            formatter: val => {
              return `llm_url.contains("${val}")`
            },
          },
          mcp_server: {
            label: this.$t('ai.mcp.mcp_server'),
            filter: true,
            formatter: val => {
              return `mcp_server.contains("${val}")`
            },
          },
        },
        steadyStatus: {
          status: expectStatus.mcp ? Object.values(expectStatus.mcp).flat() : ['ready'],
        },
        hiddenColumns: ['created_at'],
      }),
      groupActions: [
        {
          label: this.$t('common.create'),
          permission: 'mcp_agents_create',
          action: () => {
            this.createDialog('McpConfigDialog', {
              initialConfig: {},
              onManager: this.onManager,
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
              validate: true,
            }
          },
        },
      ],
    }
  },
  computed: {
    exportDataOptions () {
      return {
        downloadType: 'local',
        title: this.$t('ai.mcp.title'),
        items: this.columns,
      }
    },
  },
  created () {
    this.initSidePageTab('detail')
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        ...this.getParams,
        details: true,
      }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'McpSidePage', {
        id: row.id,
        resource: 'mcp_agents',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
  },
}
</script>
<style>

</style>
